import React from "react";
import "./TpPopUpCss.css";

const PopUpTitle = ({ title, error, ...rest }) => {
  return <div className="popup-title">{title}</div>;
};

export default PopUpTitle;
